import { render, staticRenderFns } from "./BoleaMedicamento.vue?vue&type=template&id=3c827e12&"
import script from "./BoleaMedicamento.vue?vue&type=script&lang=js&"
export * from "./BoleaMedicamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports